import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LocationResponseDto } from '../dto/response/location-response.dto';
import locationService from '../services/location.service';
import { LocationSaveRequestDto } from '../dto/request/location-save-request.dto';
import { LocationUpdateRequestDto } from '../dto/request/location-update-request.dto';
import { LocalesLanguagesConstants } from '../../../../locales/locales';

const initialState = {
  status: 'idle',
  locations: [] as LocationResponseDto[] | null,
  location: {} as LocationResponseDto | null,
  error: null as string | null,
};

// export const fetchLocationById = createAsyncThunk(
//   'locations/fetchLocationById',
//   async (id: string) => {
//     return await locationService.fetchLocationById(id);
//   }
// );

export const saveLocation = createAsyncThunk(
  'locations/saveLocation',
  async (saveRequest: LocationSaveRequestDto) => {
    return await locationService.saveLocation(saveRequest);
  }
);

export const updateLocation = createAsyncThunk(
  'locations/updateLocation',
  async (params: {
    updateRequest: LocationUpdateRequestDto;
    language: LocalesLanguagesConstants;
  }) => {
    const { updateRequest, language } = params;
    return await locationService.updateLocation(updateRequest, language);
  }
);

export const deleteLocation = createAsyncThunk(
  'locations/deleteLocation',
  async (existingId: string) => {
    return await locationService.deleteLocation(existingId);
  }
);

const locationSlice = createSlice({
  name: 'locationSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchLocationById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchLocationById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.location = action.payload;
      // })
      // .addCase(fetchLocationById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(saveLocation.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveLocation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.locations?.push(action.payload);
      })
      .addCase(saveLocation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(updateLocation.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (state.locations) {
          const locationIndex = state.locations.findIndex(
            (location) => location.id === action.payload.id
          );
          if (locationIndex !== -1) {
            state.locations[locationIndex] = action.payload;
          }
        }
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(deleteLocation.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteLocation.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteLocation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default locationSlice.reducer;
